module.exports = __webpack_public_path__ + "img/aston-form.a7500173.webp";